import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import AddPlaytimeDialog from "../AddPlaytimeDialog/AddPlaytimeDialog";

const TrialDialog = ({
  user,
  paymentGateway,
  buyOneHour = false,
  handleBuyClickFn = () => {},
  checkoutLoading,
  isOpen,
  toggleTrialDialog,
}) => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(isOpen);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild to="/pricing">
        <Button
          variant="default"
          asChild
          className="rounded-full w-min cursor-pointer"
          onClick={() => toggleTrialDialog()}
        >
          <div className={buyOneHour ? "visible" : "collapse"}>
            <div>{t("need_a_trial")}</div>
          </div>
        </Button>
      </DialogTrigger>
      <DialogContent className="bg-[var(--ring-offset)] rounded-2xl sm:rounded-2xl shadow-[0px_4px_6px_-2px_rgba(0,0,0,0.05)] shadow-lg border border-[var(--button-background)]">
        <DialogHeader>
          <DialogTitle className="text-neutral-50 text-2xl font-semibold">
            {t("what_kind_of_trial")}
          </DialogTitle>
          <DialogDescription className="text-[var(--muted-foreground)] text-sm font-medium">
            {t("trial_note")}
          </DialogDescription>
        </DialogHeader>

        {checkoutLoading ? (
          <div className="flex items-center justify-center gap-2 h-40">
            <Loader2 className="animate-spin" />
          </div>
        ) : (
          <div className="flex flex-col gap-4 w-full">
            <Button
              variant="outline"
              className="flex flex-col items-start gap-2 bg-[var(--card)] rounded-2xl p-6 h-full text-left hover:bg-[var(--button-background)]"
              onClick={() =>
                handleBuyClickFn(
                  "Starter",
                  "week",
                  "subscription",
                  1,
                  paymentGateway,
                  false
                )
              }
              disabled={checkoutLoading}
            >
              <div className="flex gap-4 text-neutral-200">
                <div className="grow">
                  <div className="text-xl font-semibold text-wrap">
                    🎮 {t("install_your_own_game")}
                  </div>
                  <div className="text-sm font-medium text-wrap">
                    {t("specific_game")}
                    <div className="font-bold">
                      You get a Private PC (100GB) with 2 hours playtime per
                      week
                    </div>
                  </div>
                </div>
                {!paymentGateway ? (
                  <div className="flex items-baseline text-foreground">
                    <Skeleton className="h-10 w-2/3" />
                  </div>
                ) : (
                  <div className="flex flex-col">
                    <div>
                      <span className="text-xl font-semibold">
                        {paymentGateway === "razorpay" ? "₹" : "$"}
                      </span>
                      <span className="text-3xl font-bold">
                        {paymentGateway === "razorpay" ? "100" : "1.50"}
                      </span>
                    </div>

                    <span className="ml-1 text-sm text-muted-foreground">
                      {paymentGateway === "razorpay" ? "+ 18% GST" : ""}
                    </span>
                  </div>
                )}
              </div>
            </Button>
            <AddPlaytimeDialog
              user={user}
              paymentGateway={paymentGateway}
              buyOneHour={true}
            />
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default TrialDialog;
